import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, MessageCircle, Monitor } from 'lucide-react';
import { LOGO_URL, CONTACT } from '../mock';

export default function Footer() {
  return (
    <footer>
      {/* Main dark footer */}
      <div style={{ background: '#1a3a5c' }} className="text-slate-200">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <div className="relative h-14 w-14 rounded-full overflow-hidden flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="AvantiTutor Logo"
                  className="h-full w-full object-cover scale-125"
                  style={{ mixBlendMode: 'lighten' }}
                />
              </div>
              <div className="flex flex-col leading-tight">
                <span className="font-extrabold text-lg text-white tracking-wider">AVANTITUTOR</span>
                <span className="text-[9px] tracking-widest text-slate-400 uppercase">{CONTACT.tagline}</span>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              Online-Nachhilfe für Schüler & Studierende – strukturiert, persönlich, einfach.
            </p>
            <div className="flex gap-3 mt-5">
              <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-9 w-9 rounded-full flex items-center justify-center transition-colors hover:brightness-125" style={{ background: '#2c4d70' }}>
                <Instagram className="h-4 w-4" />
              </a>
              <a data-testid="footer-whatsapp" href={CONTACT.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="h-9 w-9 rounded-full flex items-center justify-center transition-colors hover:brightness-110" style={{ background: '#25d366' }}>
                <MessageCircle className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Unternehmen</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/#ansatz" className="hover:text-white transition-colors">Unser Ansatz</Link></li>
              <li><Link to="/faecher" className="hover:text-white transition-colors">Fächer</Link></li>
              <li><Link to="/#preise" className="hover:text-white transition-colors">Preise</Link></li>
              <li><Link to="/blog" data-testid="footer-blog" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Schnellzugriff</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/portal" className="hover:text-white transition-colors">Schüler-Portal</Link></li>
              <li><Link to="/buchen" className="hover:text-white transition-colors">Termin buchen</Link></li>
              <li><Link to="/anmelden" className="hover:text-white transition-colors">Anmelden</Link></li>
              <li><Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Kontakt</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-center gap-2"><Mail className="h-4 w-4" style={{ color: '#4aa5c8' }} /> {CONTACT.email}</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4" style={{ color: '#4aa5c8' }} /> {CONTACT.phone}</li>
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0" style={{ color: '#4aa5c8' }} /> {CONTACT.address}</li>
              <li className="flex items-center gap-2"><Monitor className="h-4 w-4" style={{ color: '#4aa5c8' }} /> {CONTACT.mode}</li>
              <li className="flex items-center gap-2"><MessageCircle className="h-4 w-4" style={{ color: '#25d366' }} />
                <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">WhatsApp Chat</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar - flyer style */}
      <div style={{ background: '#2d7d9a' }} className="text-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 flex flex-col md:flex-row justify-between items-center gap-3 text-xs">
          <span>© {new Date().getFullYear()} AvantiTutor. Alle Rechte vorbehalten.</span>
          <div className="flex gap-5">
            <Link data-testid="footer-impressum" to="/impressum" className="hover:text-slate-200 transition-colors">Impressum</Link>
            <Link data-testid="footer-datenschutz" to="/datenschutz" className="hover:text-slate-200 transition-colors">Datenschutz</Link>
            <Link data-testid="footer-agb" to="/agb" className="hover:text-slate-200 transition-colors">AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
